import { render, staticRenderFns } from "./singleBox.vue?vue&type=template&id=735c6c3e&scoped=true&"
import script from "./singleBox.vue?vue&type=script&lang=js&"
export * from "./singleBox.vue?vue&type=script&lang=js&"
import style0 from "./singleBox.vue?vue&type=style&index=0&id=735c6c3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735c6c3e",
  null
  
)

export default component.exports